const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://dukehub.co.uk/api';
const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, '') || API_BASE_URL;

class ApiService {
  getUploadUrl(filename) {
    return `${API_ORIGIN}/api/uploads/${filename}`;
  }
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const isFormData = options.body instanceof FormData;
    
    const config = {
      ...options,
      credentials: 'include',
    };

    // Only set Content-Type for non-FormData requests
    // FormData requests should let the browser set Content-Type with boundary
    if (!isFormData) {
      config.headers = {
        'Content-Type': 'application/json',
        ...options.headers,
      };
    } else if (options.headers) {
      config.headers = options.headers;
    }

    const response = await fetch(url, config);
    
    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'An error occurred' }));
      throw new Error(error.error || `HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  // Auth endpoints
  async register(data) {
    return this.request('/auth/register', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async login(data) {
    return this.request('/auth/login', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async logout() {
    return this.request('/auth/logout', {
      method: 'POST',
    });
  }

  async getCurrentUser() {
    const url = `${API_BASE_URL}/auth/me`;
    try {
      const response = await fetch(url, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 401) {
        // Not authenticated
        return null;
      }

      if (!response.ok) {
        const error = await response.json().catch(() => ({ error: 'An error occurred' }));
        throw new Error(error.error || `HTTP error! status: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      // If it's a network error or other issue, return null
      if (error.message.includes('401') || error.message.includes('fetch')) {
        return null;
      }
      throw error;
    }
  }

  getGoogleAuthUrl() {
    return `${API_BASE_URL}/auth/google`;
  }

  // Contractor endpoints
  async getMyProfile() {
    return this.request('/contractors/me');
  }

  async saveProfile(data) {
    return this.request('/contractors/me', {
      method: 'POST',
      body: data instanceof FormData ? data : JSON.stringify(data),
    });
  }

  async submitOnboarding() {
    return this.request('/contractors/me/submit', {
      method: 'POST',
    });
  }

  async getTrades() {
    return this.request('/trades');
  }

  // Admin endpoints
  async getContractors(filters = {}) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });
    const queryString = params.toString();
    return this.request(`/admin/contractors${queryString ? `?${queryString}` : ''}`);
  }

  async getContractorById(id) {
    return this.request(`/admin/contractors/${id}`);
  }

  async updateContractorStatus(id, status) {
    return this.request(`/admin/contractors/${id}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ status }),
    });
  }

  async getAdminStats() {
    return this.request('/admin/stats');
  }
}

const apiService = new ApiService();
export default apiService;
